import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    if (window.location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/f0817863ebc92fa27256ed37b93c2254/c9a76ca18a66a27beb3da7bc5d4c0917.png" 
              alt="Congarantías SAS" 
              className="h-12 w-auto"
            />
          </Link>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-black text-2xl cursor-pointer"
          >
            <i className={isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>

          <nav className={`${
            isMenuOpen ? 'flex' : 'hidden'
          } lg:flex flex-col lg:flex-row absolute lg:relative top-20 lg:top-0 left-0 right-0 bg-white lg:bg-transparent shadow-lg lg:shadow-none items-center gap-6 py-6 lg:py-0 px-6 lg:px-0`}>
            <button
              onClick={() => scrollToSection('inicio')}
              className="text-black hover:text-gray-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('quienes-somos')}
              className="text-black hover:text-gray-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Quiénes Somos
            </button>
            <button
              onClick={() => scrollToSection('servicios')}
              className="text-black hover:text-gray-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('cobertura')}
              className="text-black hover:text-gray-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Cobertura
            </button>
            <Link
              to="/pagar-deuda"
              className="bg-amber-500 text-white px-8 py-3 rounded-lg font-bold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-base"
              onClick={() => setIsMenuOpen(false)}
            >
              <i className="ri-bank-card-line mr-2"></i>
              PAGAR DEUDA
            </Link>
            <button
              onClick={() => scrollToSection('contacto')}
              className="bg-gray-700 hover:bg-gray-800 text-white px-8 py-3 rounded-lg font-bold transition-all whitespace-nowrap cursor-pointer text-base"
            >
              <i className="ri-phone-line mr-2"></i>
              Contacto
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
}
